import RouteTemplate from 'ember-route-template'
import { t } from 'ember-intl'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect, ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import type RexReadAloudStudentController from 'teacher-ui-client/reporting/ui-scope/rex/read-aloud-fluency/student/controller'
import type RexReadAloudStudentRoute from 'teacher-ui-client/reporting/ui-scope/rex/read-aloud-fluency/student/route'
import { array } from '@ember/helper'
import { hash } from '@ember/helper'
import type { TOC } from '@ember/component/template-only'
import { ReportLoader as StudentOverviewReportLoader } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/student/overview/report-loader'
import { ReportLoader as StudentEventsReportLoader } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/student/events/report-loader'
import { CreateAssignmentLink } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/create-assignment-link'

interface Signature {
  Args: {
    model: ModelFor<RexReadAloudStudentRoute>
    controller: RexReadAloudStudentController
  }
}

export const RexReadAloudStudentPage: TOC<Signature> = <template>
  <ReportingTeacherUiHeader
    @showBack={{true}}
    @title="{{@model.student.fullName}} {{t 'reporting.pageTitles.readAloudFluency'}}"
  />
  <ReportingControls>
    <ReportingPeriodSelect />
    <ReportingControlsGap />
    <ReportingExportSelect @exportOptions={{array (hash exportType=ExportType.print)}} />
    <ReportingControlsGap />
    <CreateAssignmentLink />
  </ReportingControls>
  <div class="space-y-4">
    <StudentOverviewReportLoader @period={{@model.period}} @student={{@model.student}} />
    <StudentEventsReportLoader
      @sort={{@controller.sort}}
      @pageNumber={{@controller.pageNumber}}
      @perPage={{@controller.perPage}}
      @period={{@model.period}}
      @student={{@model.student}}
    />
  </div>
</template>

export default RouteTemplate(RexReadAloudStudentPage)
